import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import exit from './exit/exit.js'
import help from './help/help.js'

export default contract({
  exit: array ([
    exit
  ]),
  help
})
